import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/scanner-grid-3.webp")